import { render } from "./GlobalEng.vue?vue&type=template&id=8ba58670&scoped=true&lang=html"
import script from "./GlobalEng.vue?vue&type=script&lang=js"
export * from "./GlobalEng.vue?vue&type=script&lang=js"

import "./GlobalEng.vue?vue&type=style&index=0&id=8ba58670&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-8ba58670"

export default script